import axios from "axios";
import { authDeviceWithDomainHeader } from "@/helpers/authServices/auth.header";
import { setCallCenter } from "@/helpers/BatchService.js";

const API_URL = process.env.VUE_APP_ROOT_API;
class CallCenterService {
  // Call Center Agent APIs
  // Get Call Agent List
  async getAgentList(filter = "") {
    return await axios
      .get(API_URL + `call-center/agent` + filter, {
        headers: authDeviceWithDomainHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  // Get Call Agent Detail
  async getAgentDetails(agent_uuid) {
    return await axios
      .get(API_URL + `call-center/agent?call_center_agent_uuid=${agent_uuid}`, {
        headers: authDeviceWithDomainHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  // Add Call Agent
  async addAgent(data) {
    return await axios
      .post(API_URL + `call-center/agent`, data, {
        headers: authDeviceWithDomainHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  // Edit Call Agent Detail
  async updateAgentDetails(agent_uuid, data) {
    return await axios
      .put(API_URL + `call-center/agent/${agent_uuid}`, data, {
        headers: authDeviceWithDomainHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  // Edit Call Agent Detail
  async updateAgentStatus(agent_uuid, data) {
    return await axios
      .patch(API_URL + `call-center/agent/${agent_uuid}`, data, {
        headers: authDeviceWithDomainHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  //delete Call Agent Detail
  async deleteAgent(agent_uuid) {
    return await axios
      .delete(API_URL + `call-center/agent/${agent_uuid}`, {
        headers: authDeviceWithDomainHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  // Call Center APIs
  // Get Call Center List
  async getCallCenterList(filter = "") {
    return await axios
      .get(API_URL + `call-center/queue` + filter, {
        headers: authDeviceWithDomainHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  // Get Call Center Detail
  async getCallCenterDetails(dialplan_uuid) {
    return await axios
      .get(
        API_URL + `call-center/queue?call_center_queue_uuid=${dialplan_uuid}`,
        {
          headers: authDeviceWithDomainHeader(),
        }
      )
      .then((response) => {
        return response.data;
      });
  }

  // Add Call Center
  async addCallCenter(data) {
    return await axios
      .post(API_URL + `call-center/queue`, data, {
        headers: authDeviceWithDomainHeader(),
      })
      .then((response) => {
        setCallCenter();
        return response.data;
      });
  }

  // Remove abandoned call
  async remAbanCall(data) {
    return await axios
      .post(API_URL + `call-center/report/dashboard`, data, {
        headers: authDeviceWithDomainHeader(),
      })
      .then((response) => {
        setCallCenter();
        return response.data;
      });
  }

  // Edit Call Center Detail
  async updateCallCenter(dialplan_uuid, data) {
    return await axios
      .put(API_URL + `call-center/queue/${dialplan_uuid}`, data, {
        headers: authDeviceWithDomainHeader(),
      })
      .then((response) => {
        setCallCenter();
        return response.data;
      });
  }

  // Edit Call Center Detail
  async updateCallCenterStatus(dialplan_uuid, data) {
    return await axios
      .patch(API_URL + `call-center/queue/${dialplan_uuid}`, data, {
        headers: authDeviceWithDomainHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  //delete Call Center Detail
  async deleteCallCenter(dialplan_uuid) {
    return await axios
      .delete(API_URL + `call-center/queue/${dialplan_uuid}`, {
        headers: authDeviceWithDomainHeader(),
      })
      .then((response) => {
        setCallCenter();
        return response.data;
      });
  }

  // Get Call Center Detail
  async getActiveCallCenter() {
    return await axios
      .get(API_URL + `call-center/queue-active-call`, {
        headers: authDeviceWithDomainHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  // Get Call Center Detail
  async getActiveCallCenterNew(filter = "") {
    return await axios
      .get(API_URL + `call-center/report/dashboard${filter}`, {
        headers: authDeviceWithDomainHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  // Get Call Center Detail
  async getActiveCCDetailed(id) {
    return await axios
      .get(
        API_URL +
          `call-center/queue-active-call?cq.call_center_queue_uuid=${id}`,
        {
          headers: authDeviceWithDomainHeader(),
        }
      )
      .then((response) => {
        return response.data;
      });
  }

  // REPORTS APIs
  async getAgentListRep(filter = "") {
    return await axios
      .get(API_URL + `call-center/report/agent` + filter, {
        headers: authDeviceWithDomainHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  async getCallRecRep(filter = "") {
    return await axios
      .get(API_URL + `call-center/report/call-record` + filter, {
        headers: authDeviceWithDomainHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  async getCallSumRep(filter = "") {
    return await axios
      .get(API_URL + `call-center/report/queue` + filter, {
        headers: authDeviceWithDomainHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  // ! API for TV Login/Data
  async TVCCLoginCumData(filter = "", data) {
    return await axios
      .get(API_URL + `call-center/report/tv-dashboard` + filter, {
        headers: {
          "X-Access-Token": btoa(JSON.stringify(data)),
        },
      })
      .then((response) => {
        return response.data;
      });
  }
}

export default new CallCenterService();
